import { useContext, useReducer, useState } from 'react'
import React from 'react'
import reducer from './reducer'

const AppContext = React.createContext();
//Starting state
const initialState = {
    votingScreen: false,
    waitingScreen: false,
    voteFinishScreen: false,
    vote: false,
    turns: 0,
    index: 0,
    vampireCount: 1,
    deadFuckerCount: 0,
    doctorCount: 0,
    werewolfCount: 0,
    darkMatterCount: 0,
    blood: 2,
    stacks: 0,
    guess:{},
    players: [{ name: '', class: '', life: false, voteCount: 0 }, { name: '', class: '', voteCount: 0 , life: false},
    { name: '', class: '', voteCount: 0 , life: false}, { name: '', class: '', voteCount: 0 , life: false}],
    deathStatement: 'Hope you all learned your roles.Good luck!'
  }

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [play, setPlay] = useState(false);
  const [btn1, setBtn1] = useState(true);
  const [btn2, setBtn2] = useState(true);

  //Adjustments before the game starts
  const changePlayerCount = (number) => {
      dispatch({type:'CHANGE_COUNT', payload: number})
  }

  const changeVampireCount = (number) => {
    dispatch({type:'CHANGE_VAMPIRE_COUNT', payload: number})
  }

  const changeName = (e, index) => {
      let name = e.target.value;
      dispatch({type:'CHANGE_NAME', payload:{name, index}})
  }

  const classHandler = (trait) => {
      dispatch({type:'HANDLE_CLASS', payload: trait})
  }

  //After clicking the start button
  const startGame = () => {
    dispatch({ type: 'START_GAME' })
    setPlay(true);
  }

  const openWaitingScreen = (index) => {
    if (index === state.players.length - 1)
      dispatch({ type: 'NEXT_PLAYER', payload: index })
    else
      dispatch({type: 'WAITING_SCREEN'})
  }

  const nextPlayer = (index) => {
      dispatch({type:'NEXT_PLAYER', payload:index})
  }
  
  //Class skills

  //Vampire
  const voteForKill = (index) => {
      dispatch({ type: 'KILL_VOTE', payload: index })
  }

  //Plague Doctor
  const guard = (index) => {
      dispatch({type: 'GUARD_PLAYER', payload: index})
  }

  //Dead Fucker
  const guessDeath = (index) => {
    dispatch({ type: 'GUESS_DEATH', payload: index })
  }

  //Werewolf
  const bite = (index) => {
    dispatch({type: 'WEREWOLF_BITE', payload: index})
  }

  //Dark Matter
  const changeClass = (trait, index) => {
    dispatch({ type: 'TRANSFORM', payload: { trait, index } })
  }

  //Dracula
  const resetBlood = () => {
    dispatch({type: 'RESET_BLOOD'})
  }

  const saveFromBite = (index) => {
    dispatch({ type: 'ANTI_MARK', payload: index })
  }

  //Warrior
  const slay = (index) => {
    dispatch({ type: 'SLAY_VAMPIRE', payload: index})
  }

  //Voting
  const nextVoter = (index) => {
    dispatch({ type: 'NEXT_VOTER', payload: index})
  }

  const finishVoting = () => {
    dispatch({type: 'FINISH_VOTE'})
  }

  const startNextTurn = () => {
    dispatch({ type: 'NEXT_TURN' })
  }

  return (
      <AppContext.Provider
      value={{
        changePlayerCount, changeVampireCount, changeName, classHandler, play,
        startGame, nextPlayer, openWaitingScreen, voteForKill, guessDeath, changeClass,
        guard, bite, resetBlood, saveFromBite,slay, nextVoter, finishVoting, startNextTurn,
        btn1, setBtn1, btn2, setBtn2, ...state
      }}
      >
        {children}
      </AppContext.Provider>
    )

}

export const useGlobalContext = () => {
    return useContext(AppContext)
}
  
export { AppContext, AppProvider }